import { getFunctions, httpsCallable, HttpsCallableResult } from 'firebase/functions';
import { Req, Res } from '@cbo/shared-library';
import { LinkRole } from '../admin/EditLinksPage/EditLinksPage';

export const cboRoleToLegacyRoleNames: Record<LinkRole, string> = {
  [LinkRole.ADMIN_LINK_VIEWER]: 'CBO_ADMIN',
  [LinkRole.ASSISTANT_MANAGER_LINK_VIEWER]: 'CBO_ASSISTANT_MANAGER',
  [LinkRole.EMPLOYEE_LINK_VIEWER]: 'CBO_EMPLOYEE',
  [LinkRole.SHIFT_LEADER_LINK_VIEWER]: 'CBO_SHIFT_LEADER',
  [LinkRole.SUPPORT_LINK_VIEWER]: 'CBO_SUPPORT',
  [LinkRole.ABOVE_STORE_MANAGER_LINK_VIEWER]: 'CBO_ABOVE_STORE_MANAGER',
  [LinkRole.STORE_MANAGER_LINK_VIEWER]: 'CBO_RESTAURANT_MANAGER',
  [LinkRole.GENERAL_MANAGER_LINK_VIEWER]: 'CBO_GENERAL_MANAGER',
  [LinkRole.ACCOUNTANT_LINK_VIEWER]: 'CBO_ACCOUNTANT',
};

const everyoneRoleNames = Object.values(LinkRole).map((role) => cboRoleToLegacyRoleNames[role]);
const isViewerEveryone = (link: Res.Firebase.Link): boolean =>
  everyoneRoleNames.every((roleName) => !!link.readRoles?.find((role) => role.id === roleName));
const everyoneRole: Res.Firebase.DocumentRole = {
  id: 'Everyone',
  name: 'Everyone',
  description: 'Everyone',
};

export const getAllLinks = async (filterByUserRoles?: boolean): Promise<Res.Firebase.Link[]> => {
  const functions = getFunctions();
  const getOrganizationLinks = httpsCallable(functions, 'getOrganizationLinks2');
  const res: HttpsCallableResult = await getOrganizationLinks({ body: { filterByUserRoles } });
  const results = (res.data as Res.Firebase.Link[]).map((link) =>
    isViewerEveryone(link)
      ? {
          ...link,
          readRoles: [everyoneRole],
        }
      : link
  );
  return results;
};

export const addNewLink = async (link: Req.Firebase.LinkData) => {
  const functions = getFunctions();
  const addLink = httpsCallable(functions, 'addLink2');
  const res: HttpsCallableResult = await addLink({ body: link });
  return res.data as Res.Firebase.Link;
};

export const deleteCompanyLink = async (linkId: string): Promise<string> => {
  const functions = getFunctions();
  const deleteLink = httpsCallable(functions, 'deleteLink2');
  const res: HttpsCallableResult = await deleteLink({ body: { id: linkId } });
  return res.data as string;
};

export const editLink = async (link: Req.Firebase.Link) => {
  const functions = getFunctions();
  const updateLink = httpsCallable(functions, 'updateLink2');
  const res: HttpsCallableResult = await updateLink({ body: link });
  return res.data as Res.Firebase.Link;
};
